const ITEMS = [
  "FREE DELIVERY OVER R750",
  "PRESCRIBED SCHOOL PACKS",
  "SAME-WEEK DISPATCH",
  "100% GENUINE TEXTBOOKS",
  "COLLECT IN STORE",
  "BULK & CORPORATE QUOTES",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-gold overflow-hidden py-3" data-testid="perks-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((t, i) => (
              <span
                key={`${half}-${i}`}
                className="font-display font-extrabold text-white text-sm tracking-[0.2em] uppercase mx-6 flex items-center gap-6"
              >
                {t}
                <span className="w-1.5 h-1.5 rounded-full bg-navy-dark/40 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
